import { createSelector } from '@ngrx/store';
import {
  selectAdvertiserFilter,
  selectAdvertiserPage,
  selectAdvertisers,
  selectOrganizations,
  selectPublisherFilter,
  selectPublisherPage,
  selectPublishers
} from './accounts.feature';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';
import { getVisibleAccounts } from './accounts.helpers';

export const selectVisiblePublishers = createSelector(
  selectPublishers,
  selectPublisherPage,
  selectPublisherFilter,
  (publishers, page, searchTerm): ICreateAccount[] => getVisibleAccounts(publishers, searchTerm, page),
);

export const selectVisibleAdvertisers = createSelector(
  selectAdvertisers,
  selectAdvertiserPage,
  selectAdvertiserFilter,
  (advertisers, page, searchTerm): ICreateAccount[] => getVisibleAccounts(advertisers, searchTerm, page),
);

export const selectAreOrganizationsNotEmpty = createSelector(
  selectOrganizations,
  organizations => organizations.length > 0,
);
